import { MutableRefObject, useEffect, useState } from 'react'
import {
  gridColumnsTotalWidthSelector,
  GridScrollParams,
} from '@mui/x-data-grid-premium'
import { GridApiPremium } from '@mui/x-data-grid-premium/models/gridApiPremium'
import { useDebouncedCallback } from 'use-debounce'

const useShowScrollShadow = (apiRef: MutableRefObject<GridApiPremium>) => {
  const [showShadow, setShowShadow] = useState(false)

  const handleScroll = (params: GridScrollParams) => {
    const { left } = params
    const columnsTotalWidth = gridColumnsTotalWidthSelector(apiRef)
    const dimensions = apiRef.current.getRootDimensions()

    if (
      Math.round(left + dimensions!.viewportOuterSize.width) >=
      columnsTotalWidth
    ) {
      setShowShadow(false)
    } else {
      setShowShadow(true)
    }
  }

  const debouncedHandleScroll = useDebouncedCallback(handleScroll, 50, {
    maxWait: 250,
  })

  useEffect(() => {
    return apiRef.current.subscribeEvent(
      'scrollPositionChange',
      debouncedHandleScroll,
    )
  }, [apiRef, debouncedHandleScroll])

  return showShadow
}

export { useShowScrollShadow }
